<template>
<div id="osago">
    <sravni-widget  type='osago' theme='sravni_blue' width='1000' partner='v-avtoservis-r-f' inIframe='false' hide-partners='true'></sravni-widget>
</div>
</template>

<script>
export default {
  name: 'osago'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blocks/osago.vue